/* global nubeeGlobals */

/*** Importations *********************************************************************************/

import objectFitImages from 'object-fit-images/dist/ofi.es-modules.js';
import smoothscroll from 'smoothscroll-polyfill';


// Libraries

// import InfiniteScroll from 'infinite-scroll';
import LazyLoad from 'vanilla-lazyload/dist/lazyload.esm.js';
import Swiper from 'swiper';
import {
	Autoplay,
	Pagination,
	Navigation,
	// EffectFade
} from 'swiper/modules';
// import { CountUp } from 'countup.js';

// Scripts Nubee

// import toggleSearchForm from 'partials/toggle-search-form.js';
// import * as nubeeLoading from 'partials/nubee-loading.js';
// import Tabs from 'partials/tabs.js';
import Accordion from 'partials/accordion.js';
import * as functions from 'partials/functions.js';
import 'partials/scroll-interval.js';
import 'partials/target-blank-security.js';
// import placeholderLabelUpdate from 'partials/placeholder-label.js';
import GLightboxNubee from 'partials/glightbox-nubee.js';
// import googleMapStyles from 'data/google-map-styles.js';
// import GoogleMap from 'partials/google-map.js';
import MobileMenu from 'partials/mobile-menu.js';
import imgCheck from 'partials/img-check.js';
// import InfiniteScrollSimple from 'partials/infinite-scroll-simple.js';
// import LoadingButton from 'partials/loading-button.js';
// import FakeSticky from 'partials/fake-sticky.js';
import * as cookiesBar from 'partials/cookies-bar.js';
// import ProgressiveMenu from 'partials/progressive-menu.js';

// Inclusion pour ajouter des fonctions à Gravity Forms
import GravityFormsConditionalLogic from 'partials/gf-conditional-logic.js';
import * as nubeeGFDropzone from 'partials/nubee-gravity-forms-dropzone.js';

// On set toutes les variables globales et évènements qui les modifient ici
import * as globalVarFunctions from 'partials/global-variables.js';

(function() {
	/*** Application des polyfills ********************************************************************/

	(function() {
		objectFitImages();
		smoothscroll.polyfill();

		if( 'function' != typeof window.Event ) {
			window.Event = CustomEvent;
		}
	}) ();


	/*** Variables globales ***************************************************************************/
	// global-variables.js
	// Chaînes traduisibles et autres variables provenant de theme-functions : window.nubeeGlobals.i18n.monPlugin.nomDeChaine

	globalVarFunctions.setGlobalVariables();


	/*** Les liens avec ancre qui mènent vers la même page deviennent seulement des ancres *******************/
	// Requiert functions.urlsAreSamePage
	// Requiert functions.arrayAllEqual

	(function() {
		let linksWithHash = document.querySelectorAll('a[href*="#"]');

		linksWithHash.forEach( function( thisLink ) {
			if( functions.urlsAreSamePage({ urls: [ thisLink.href, window.location.href ] }) ) {
				thisLink.href = thisLink.hash;
			}
		} );
	}) ();


	/*** Défiler doucement les liens ancres *******************************************************************/
	// Requiert window.smoothScroller (smooth-scroller.js), initialisé dans global-variables.js
	// Ajuster la variable globale window.fixedElHeight

	(function() {
		if( window.smoothScroller ) {
			let smoothScrollLinks = document.querySelectorAll('a[href^="#"]:not([href="#"]):not(.no-smooth-scroll):not([target])');

			smoothScrollLinks.forEach( function( thisEl ) {
				if( functions.scriptsOk( thisEl ) ) {
					thisEl.addEventListener( 'click', function( event ) {
						if( 1 == event.which ) {
							event.preventDefault();
							window.smoothScroller.scrollTo({ target: thisEl.hash });
						}
					} );
				}
			});
		}
	}) ();


	/*** Ne rien faire au clic sur un lien vide (#) ************************************************************/

	(function() {
		document.addEventListener( 'click', function( event ) {
			if( 1 == event.which ) {
				let linkClicked = event.target.closest('a');
				let theHref = linkClicked ? linkClicked.getAttribute('href') : null;

				if( linkClicked && ( ! theHref || '#' == theHref ) && functions.scriptsOk( linkClicked ) ) {
					event.preventDefault();
				}
			}
		} );
	}) ();


	/*** Images et backgrounds différents selon la taille de l'écran ********************************/
	// Requiert img-check.js

	(function() {
		if( 'function' == typeof imgCheck ) {
			window.addEventListener( 'resize', imgCheck );
			imgCheck();
		}
	}) ();


	/*** Lazy load des images et backgrounds *******************************************************************/
	// Requiert vanilla-lazyload

	(function() {
		let loadedEvent = new Event( 'lazyloaded' );

		window.siteLazyLoad = new LazyLoad({
			elements_selector: '.lazy',
			class_loading: 'lazy-loading',
			class_loaded: 'lazy-loaded',
			class_error: 'lazy-error',
			// use_native: true,
			callback_loaded: function( element ) {
				element.dispatchEvent( loadedEvent );
			},
		});
	}) ();


	/*** Google Maps ******************************************************************************************/
	// Requiert google-map.js
	// Requiert data/google-map-styles.js (copier-coller votre style là-dedans!)

	/*(function() {
		let mapParents = document.querySelectorAll('.the-map');

		mapParents.forEach( function( thisParent ) {
			if( functions.scriptsOk( thisParent ) ) {
				new GoogleMap({
					mapParent: thisParent,
					styles: googleMapStyles,
					markerIconUrl: window.nubeeGlobals.themeDir + '/assets/images/map-marker.svg'
				});
			}
		} );
	}) ();*/

	/*** Antispam maison sur les commentaires ****************************************************************/
	// À moins d'avoir activé le JS, la validation PHP refusera le commentaire.

	(function() {
		let commentForms = document.querySelectorAll('#commentform');

		commentForms.forEach( function( thisForm ) {
			thisForm.addEventListener( 'submit', function() {
				let legitInput = document.createElement( 'input' );
				legitInput.setAttribute( 'type', 'hidden' );
				legitInput.setAttribute( 'name', 'is_legit' );
				legitInput.value = 1;

				thisForm.appendChild( legitInput );
			} );
		} );
	}) ();


	/*** Gravity Forms : Faire fonctionner les trucs qui ne fonctionne plus suite à la désactivation de jQuery **/
	(function() {
		// Mettre les label Gravity Forms en mode focus quand ils ont une valeur
		document.querySelectorAll( '.gfield, .wpgmza-form-row' ).forEach( function( thisFormRow ) {
			thisFormRow.querySelectorAll( 'input:not([type="checkbox"]):not([type="radio"]), textarea, select' ).forEach( function( thisField ) {
				// console.log( thisField.placeholder );
				setTimeout( function() {
					if( thisField.value !== '' || ( thisField.placeholder !== '' && thisField.placeholder !== undefined ) ) { thisFormRow.classList.add( 'has-value' ); }
				}, 100 );

				thisField.addEventListener( 'change', function(){
					if( thisField.value !== '' || ( thisField.placeholder !== '' && thisField.placeholder !== undefined ) ) {
						thisFormRow.classList.add( 'has-value' );
					} else {
						thisFormRow.classList.remove( 'has-value' );
					}
				} );
			} );
		} );

		// Désactiver le bouton après un click dans les formulaires Gravity Forms
		/* document.querySelectorAll( '.gform_button' ).forEach( function( thisButton ) {
			thisButton.addEventListener( 'click', function() {
				thisButton.closest('form').submit();
				thisButton.disabled = true;
			} );
		} ); */

		// Scripts pour faire fonctionner Turnstile
		window.nubeeInitTurnstile = function() {
			if( typeof turnstile === 'undefined' || typeof turnstile.render !== 'function' ) {
				return;
			}
		
			document.querySelectorAll( '.nubee-turnstile' ).forEach( function( el ) {
				if( el.dataset.nubeeRendered === '1' ) {
					return;
				}
		
				el.dataset.nubeeRendered = '1';
		
				var form = el.closest( 'form' );
				var hidden = form ? form.querySelector( 'input[name="nubee-turnstile-token"]' ) : null;
		
				try {
					turnstile.render( el, {
						sitekey: nubeeGlobals.turnstile.key,
						callback: function( token ) {
							if( hidden ) {
								hidden.value = token;
							}
						},
						'expired-callback': function() {
							if( hidden ) {
								hidden.value = '';
							}
						},
						'error-callback': function() {
							if( hidden ) {
								hidden.value = '';
							}
						}
					} );
				} catch( err ) {
					console.error( '[Turnstile render failed]', err );
					// Permet de retenter plus tard si Turnstile n’était pas prêt.
					el.dataset.nubeeRendered = '0';
				}
			} );
		};

		window.nubeeTurnstileOnload = function() {
			window.nubeeInitTurnstile();
		};
	
		function nubeeObserveTurnstile() {
			var observer = new MutationObserver( function() {
				if( typeof window.nubeeInitTurnstile === 'function' ) {
					window.nubeeInitTurnstile();
				}
			} );
		
			observer.observe( document.body, { childList: true, subtree: true } );
		}
		
		document.addEventListener( 'DOMContentLoaded', function() {
			nubeeObserveTurnstile();
		} );
	
		// Gravity Forms peut re-render (logique conditionnelle, etc.)
		document.addEventListener( 'gform_post_render', function() {
			window.nubeeInitTurnstile();
		} );

		// Si on a un gravityForms avec un file upload dans la page, on le bind sur notre script pour gérer tout ça
		document.querySelectorAll( '.gform_wrapper form' ).forEach( function( theForm, index ) {
			theForm.querySelectorAll('.gform_fileupload_multifile').forEach(function(el, i) {
			  nubeeGFDropzone.nubeeGFDropzone(theForm.dataset.formid, 'customDropzone-' + theForm.dataset.formid + '-' + (i+1));
			});
		});

		// On va faire fonctionner le système de logique conditionnelles
		document.querySelectorAll( '.gform_wrapper > form' ).forEach( function( thisForm ) {
			new GravityFormsConditionalLogic( thisForm );
		});

		document.querySelectorAll( '.gform_wrapper > form input[value="gf_other_choice"]' ).forEach( function( thisRadio ) {
			thisRadio.addEventListener( 'change', function() {
				const wrapper = thisRadio.closest('.gchoice');

				const otherInput = wrapper ? wrapper.querySelector('.gchoice_other_control') : null;

				if( !otherInput ) return;

				// Fonction pour activer/désactiver en fonction de l'état du bouton radio
				otherInput.disabled = ! thisRadio.checked;

				if( ! otherInput.disabled ) {
					otherInput.value = ''; // vider le champ s’il est désactivé
					otherInput.focus();
				}
			} );
		});
	}) ();

	/*** Retour en haut **************************************************************************************/
	// Requiert window.smoothScroller (smooth-scroller.js), initialisé dans global-variables.js

	(function() {
		let backToTop = document.querySelector('.back-to-top');

		if( backToTop && functions.scriptsOk( backToTop ) ) {
			backToTop.addEventListener( 'click', function() {
				if( 1 == event.which ) {
					window.smoothScroller.scrollTo({ target: document.body });
				}
			} );
		}
	}) ();


	/*** Menu mobile maison **********************************************************************************/

	(function() {
		new MobileMenu({
			menuSel: '.mobile-menu',
			buttonSel: '.mobile-menu-button',
			// debug: true,
			dropdownParentLinkActive: false,

			// Si on agrandit la fenêtre dans ce media query, le menu se ferme automatiquement.
			closeMediaQuery: '(min-width: 1000px)',

			// viewportMax: { width: 699 },
		});
	}) ();


	/*** Menu progressif (bureau et mobile tout-en-un) ****************************************************/
	// Requiert progressive-menu.js
	/*(function() {
		var progressiveMenu = new ProgressiveMenu({
			mainMenuSel: '.progressive-menu .main-menu',
			moreContainerSel: '.progressive-menu .more-container',
			moreMenuSel: '.progressive-menu .more-menu',
			moreButtonSel: '.progressive-menu .more-button',
			// Attention : 'center' et 'bottom' sont pas tout à fait au point. À ajuster quand le moment viendra.
			alignWith: 'top',
			debug: false,
		});

		if( document.fonts.ready ) {
			document.fonts.ready.then(function() {
				progressiveMenu.update();
			});
		}

		window.addEventListener( 'load', progressiveMenu.update );
		window.addEventListener( 'resize', progressiveMenu.update );
	}) (); */


	/*** Recherche qui s'ouvre/ferme en cliquant sur la loupe ************************************************/
	// Requiert toggle-search-form.js

	/*
	(function() {
		if( 'undefined' !== typeof toggleSearchForm ) {
			document.querySelectorAll('.search-form .search-button').forEach( function( thisEl ) {
				thisEl.addEventListener( 'click', function() {
					if( 1 == event.which ) {
						if( ! thisEl.closest('.search-form').classList.contains('open') ) {
							toggleSearchForm( event );
						} else {
							thisEl.closest('form').submit();
						}
					}
				} );
			} );
		}
	}) ();
	*/


	/*** InfiniteScrollSimple - Version maison plus légère *************************************************/
	// Requiert infinite-scroll-simple.js
	// Requiert regenerator-runtime (Babel veut ça pour les fonctions async)
	// Voir le début du fichier pour des events sur lesquels vous hooker

	/* (function() {
		let infiniteContainers = document.querySelectorAll('.iss-container');

		infiniteContainers.forEach(function( thisEl ) {
			if( functions.scriptsOk( thisEl ) ) {
				new InfiniteScrollSimple({
					container: thisEl,
					useInner: true,
					animate: true,
					hideButton: false,
					// debug: true,
				});
			}
		} );

	}) (); */


	/*** LoadingButton - bouton pour AJAX avec preloader intégré *******************************************/

	/* (function() {
		let buttons = document.querySelectorAll('.loading-button');

		buttons.forEach(function( thisEl ) {
			if( functions.scriptsOk( thisEl ) ) {
				new LoadingButton({
					buttonEl: thisEl,
					debug: false,
				});

				// Le bouton est maintenant initialisé. On peut l'activer avec les méthodes :
				// buttonInstance.loadingStart() | buttonInstance.loadingEnd()
				// Fonctionnent aussi :
				// thisEl._loadingButton.loadingStart() | thisEl._loadingButton.loadingEnd()
			}
		} );
	}) (); */


	/*** Sliders Swiper Partners ********************************************************************************/
	// Requiert Swiper

	(function() {
		new Swiper( '.page-block-partners .swiper', {
			modules: [ Navigation, Autoplay ],
			speed: 400,
			spaceBetween: 20,
			slidesPerView: 2,
			direction: 'horizontal',
			loop: true,
			preventInteractionOnTransition: true,
			preventClicks: false,
			preventClicksPropagation: true,
			effect: 'slide',
			preloadImages: true,
			shortSwipes: true,
			lazy: { loadPrevNext: true },
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev'
			},
			breakpoints: {
				700: { slidesPerView: 3, spaceBetween: 30 },
				1400: { slidesPerView: 4, spaceBetween: 40 },
				1800: { slidesPerView: 5, spaceBetween: 40 }
			},
			on: {
				beforeLoopFix: function() {
					if( window.siteLazyLoad && window.siteLazyLoad.update ) {
						window.siteLazyLoad.update();
					}
				}
			}
		});
	})();

	( function() {

		const initTeamSwiper = function( thisBlock ) {
	
			const thisSwiperEl = thisBlock.querySelector( ".swiper" );
			if( !thisSwiperEl ){
				return;
			}
	
			const thisSwiperNext = thisBlock.querySelector( ".swiper-button-next" );
			const thisSwiperPrev = thisBlock.querySelector( ".swiper-button-prev" );
	
			let swiperInstance = null;
	
			const getSlidesCount = function() {
				return thisSwiperEl.querySelectorAll( ".swiper-slide" ).length;
			};
	
			const getSlidesPerViewForWidth = function( baseConfig ) {
				const w = window.innerWidth;
				let spv = baseConfig.slidesPerView;
	
				if( baseConfig.breakpoints ){
					const points = Object.keys( baseConfig.breakpoints )
						.map( function( k ) { return Number( k ); } )
						.sort( function( a, b ) { return a - b; } );
	
					points.forEach( function( bp ) {
						if( w >= bp && baseConfig.breakpoints[ bp ] && baseConfig.breakpoints[ bp ].slidesPerView !== undefined ){
							spv = baseConfig.breakpoints[ bp ].slidesPerView;
						}
					} );
				}
	
				return spv;
			};
	
			const toggleNavigation = function( show ) {
				[ thisSwiperNext, thisSwiperPrev ].forEach( function( el ) {
					if( !el ){
						return;
					}
	
					el.style.display = show ? "" : "none";
					el.setAttribute( "aria-hidden", show ? "false" : "true" );
					el.tabIndex = show ? 0 : -1;
				} );
			};
	
			const buildConfig = function() {
	
				const config = {
					modules: [ Navigation ],
					speed: 400,
					spaceBetween: 20,
					slidesPerView: 1,
					direction: "horizontal",
					loop: true,
					preventInteractionOnTransition: true,
					preventClicks: false,
					preventClicksPropagation: true,
					effect: "slide",
					preloadImages: true,
					shortSwipes: true,
					lazy: {
						loadPrevNext: true,
					},
					navigation: {
						nextEl: thisSwiperNext,
						prevEl: thisSwiperPrev,
					},
					breakpoints: {
						550: { slidesPerView: 2 },
						1100: { slidesPerView: 3 },
						1550: { slidesPerView: 4 },
					},
					on: {
						beforeLoopFix: function() {
							if( window.siteLazyLoad && window.siteLazyLoad.update ){
								window.siteLazyLoad.update();
							}
						},
					},
				};
	
				const slidesCount = getSlidesCount();
				const spv = getSlidesPerViewForWidth( config );
				const canLoop = slidesCount > spv;
	
				config.loop = canLoop;
	
				if( !canLoop ){
					config.allowTouchMove = false;
				}
	
				toggleNavigation( canLoop );
	
				return config;
			};
	
			const mount = function() {
				swiperInstance = new Swiper( thisSwiperEl, buildConfig() );
			};
	
			const unmount = function() {
				if( swiperInstance ){
					swiperInstance.destroy( true, true );
					swiperInstance = null;
				}
			};
	
			let lastKey = "";
	
			const refresh = function() {
				const config = buildConfig();
				const slidesCount = getSlidesCount();
				const spv = getSlidesPerViewForWidth( config );
				const key = [ slidesCount, spv, config.loop ].join( "-" );
	
				if( key === lastKey ){
					return;
				}
	
				lastKey = key;
				unmount();
				mount();
			};
	
			// Init
			refresh();
	
			// Resize
			window.addEventListener( "resize", function() {
				refresh();
			} );
		};
	
		document.querySelectorAll( ".page-block-team" ).forEach( function( thisBlock ) {
			initTeamSwiper( thisBlock );
		} );
	
	} )();

	/*(function() {
		new Swiper( '.page-block-latest-news .swiper', {
			modules: [ Navigation, Autoplay ],
			speed: 400,
			spaceBetween: 60,
			slidesPerView: 1,
			direction: 'horizontal',
			loop: false,
			touchEventsTarget: 'wrapper',
			preventInteractionOnTransition: true,
			preventClicks: false,
			preventClicksPropagation: false,
			effect: 'slide',
			preloadImages: true,
			shortSwipes: false,
			lazy: {
				loadPrevNext: true,
			},
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
			breakpoints: {
				500: { slidesPerView: 2, },
				1000: { slidesPerView: 3, },
				1900: { slidesPerView: 4, },
  			},
			on: {
				beforeLoopFix: function( ) {
					window.siteLazyLoad.update();
				}
			},
		});

	}) ();*/

	/*(function() {
		new Swiper( '.page-block-testimonials .swiper', {
			modules: [ Navigation, Autoplay ],
			speed: 400,
			spaceBetween: 25,
			slidesPerView: 1,
			direction: 'horizontal',
			loop: true,
			touchEventsTarget: 'wrapper',
			preventInteractionOnTransition: true,
			preventClicks: false,
			preventClicksPropagation: false,
			effect: 'slide',
			preloadImages: true,
			shortSwipes: true,
			autoplay: {
				delay: 5000,
			},
			lazy: {
				loadPrevNext: true,
			},
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
			breakpoints: {
				1000: { slidesPerView: 2, spaceBetween: 50, autoplay: false, },
				1800: { slidesPerView: 2, spaceBetween: 75, autoplay: false, },
				1950: { slidesPerView: 3, spaceBetween: 75, autoplay: false, },
  			},
			on: {
				beforeLoopFix: function( ) {
					window.siteLazyLoad.update();
				}
			},
		});

	}) ();*/

	(function() {
		new Swiper( '.page-block-image-text-juxta.image-type-slider .swiper', {
			modules: [ Pagination, Autoplay ],
			speed: 400,
			spaceBetween: 0,
			slidesPerView: 1,
			direction: 'horizontal',
			loop: true,
			grabCursor: true,
			touchEventsTarget: 'wrapper',
			preventInteractionOnTransition: true,
			preventClicks: false,
			preventClicksPropagation: false,
			effect: 'slide',
			preloadImages: true,
			shortSwipes: true,
			lazy: {
				loadPrevNext: true,
			},
			autoplay: {
				delay: 5000,
			},
			pagination: {
				el: ".swiper-pagination",
				type: 'bullets',
				clickable: true,
			},
			on: {
				beforeLoopFix: function( ) {
					window.siteLazyLoad.update();
				}
			},
		});

	}) ();


	/*** Empêcher la taille d'un élément de se réajuster une fois le chargement terminé ***********************/

	/* (function() {
		let lockedHeightEls = document.querySelectorAll('.lock-height-on-load');

		window.addEventListener( 'load', function() {
			lockedHeightEls.forEach( function( thisEl ) {
				if( functions.scriptsOk( thisEl ) ) {
					thisEl.style.height = thisEl.offsetHeight + 'px';
					thisEl.style.minHeight = 0;
					thisEl.style.maxHeight = 'none';
				}
			} );
		} );
	}) (); */


	/*** Select qui redirigent quand on choisit une option ******************************************************/
	// Requiert functions.urlsAreSamePage
	// Requiert functions.arrayAllEqual

	/* (function() {
		let linkSelects = document.querySelectorAll('.link-select');

		linkSelects.forEach( function( thisSelect ) {
			if( functions.scriptsOk( thisSelect ) ) {
				[ 'change', 'keypress' ].forEach( function( eventName ) {
					thisSelect.addEventListener( eventName, function() {
						let selectedOption = thisSelect.options[ thisSelect.selectedIndex ];
						let targetUrl = selectedOption.dataset.url;

						if( targetUrl ) {
							if( /^#.+/.test( targetUrl ) ) {
								window.smoothScroller.scrollTo({ target: targetUrl });
							} else if( ! functions.urlsAreSamePage({ urls: targetUrl }) ) {
								window.location.href = targetUrl;
							}
						}
					} );
				} );
			}
		} );
	}) (); */


	/*** Défile doucement au chargement d'une URL avec ancre ***************************************************/
	// Évènement "hashblocked" pour dire que le jump par défaut vient d'être bloqué
	// Évènement "initialscrollstart" pour dire qu'on s'apprête à faire le scroll
	// Évènement "initialscrollend" pour dire que la page est chargée ET l'ancre active est scrollée
	// S'il n'y a pas d'ancre (#) active, l'évènement est lancé dès le chargement.
	// Requiert window.smoothScroller (smooth-scroller.js), initialisé dans global-variables.js

	(function() {
		let origHash = window.location.hash;
		let hashBlockedEvent = new Event( 'hashblocked' );
		let scrollStartEvent = new Event( 'initialscrollstart' );
		let scrollEndEvent = new Event( 'initialscrollend' );

		if( origHash ) {
			let targetEl = document.querySelector( origHash );

			if( targetEl ) {
				window.addEventListener( 'hashblocked', function() {
					window.addEventListener( 'smoothscrollend', function initialScrollEnd() {
						window.dispatchEvent( scrollEndEvent );
						window.removeEventListener( 'smoothscrollend', initialScrollEnd );
					} );

					window.dispatchEvent( scrollStartEvent );

					window.smoothScroller.scrollTo({
						target: origHash,
						historyState: history.state,
						historyAction: 'replace',
						// debug: true,
					});
				} );


				// Blocage du jump du navigateur par défaut
				setTimeout( function() {
					functions.changeHashWithoutScrolling( null, history.state, 'replace' );
					window.scrollTo( 0, 0 );
					window.dispatchEvent( hashBlockedEvent );
				}, 1 );
			} else {
				window.dispatchEvent( scrollEndEvent );
			}
		} else {
			window.dispatchEvent( scrollEndEvent );
		}
	}) ();


	/*** smoothFadeIn - effet d'apparition lorsque dans le viewport *****************************************/
	// Requiert functions.smoothFadeIn
	// Options dans general-styles.scss

	/* (function() {
		let fadeInItems = document.querySelectorAll('.smooth-fade-in');

		fadeInItems.forEach( function( thisEl ) {
			functions.smoothFadeIn( thisEl );

			window.addEventListener( 'scrollinterval', function() {
				functions.smoothFadeIn( thisEl );
			} );
		} );
	}) (); */

	/*** ProgressiveFadeIn - effet d'apparition lorsque dans le viewport *****************************************/
	// Requiert functions.progressiveFadeIn
	// Options dans progressive-fade-in.scss
	(function() {
		let fadeInItems = document.querySelectorAll('.progressive-fade-in');

		fadeInItems.forEach( function( thisEl ) {
			functions.progressiveFadeIn( thisEl );

			window.addEventListener( 'scrollinterval', function() {
				functions.progressiveFadeIn( thisEl );
			} );
		} );
	}) ();



	/*** Onglets ***************************************************************************************/
	// Requiert tabs.js


	/*(function() {
		let tabsContainers = document.querySelectorAll('.tabs-block');

		tabsContainers.forEach( function( thisEl ) {
			new Tabs({
				container: thisEl,
				debug: true,
			});
		} );
	}) ();*/



	/*** Accordion *************************************************************************************/
	// Requiert accordion.js


	(function() {
		let accordionsEl = document.querySelectorAll('.accordion .accordion-item');

		accordionsEl.forEach( function( el ) {
			new Accordion( el );
		} );
	}) ();


	/*** Tooltips tippy *************************************************************************************/
	// Requiert tippy.js
	/*
	(function() {
		tippy( '[data-tippy-content]', {
			theme: 'light',
			flipBehavior: [ 'bottom', 'left' ],
		} );
	}) ();
	*/


	/*** Lightbox et popups avec GLightbox ******************************************************************/
	// Requiert GLightbox (glightbox)
	// Requiert glightbox-nubee.js

	(function() {
		// Éléments seuls.
		let lightboxEls = document.querySelectorAll('.lightbox');
		lightboxEls.forEach( function( thisEl ) {
			if( functions.scriptsOk( thisEl ) ) {
				new GLightboxNubee({
					links: thisEl,
					// debug: true,
				});
			}
		} );

		// Galeries. (Attention de donner une classe différente à chaque galerie de la page.)
		// Utilisez data-lightbox-element-class="ma-classe" sur .lightbox-gallery pour l'identifier.
		let lightboxGals = document.querySelectorAll('.lightbox-gallery');
		lightboxGals.forEach( function( thisGal ) {
			if( functions.scriptsOk( thisGal ) ) {
				new GLightboxNubee({
					galleryParent: thisGal,
					// debug: true,
				});
			}
		} );

		// On peut maintenant accéder aux instances à partir des liens ou du parent de la galerie :
		// <un lien lightbox ou un div galerie>._GLightboxNubee
		// <un lien lightbox ou un div galerie>._GLightbox
	}) ();


	/*** Aller voir s'il y a des annonces a afficher *******************************/
	/*( function() {

		setTimeout( function( ) {

			let formData = new FormData();

			formData.append( 'action', 'announcement' );
			formData.append( 'post_id', nubeeGlobals.current_post.post_id );
			formData.append( 'post_type', nubeeGlobals.current_post.post_type );

			// console.log(atnGlobals.ajaxUrl);

			fetch( nubeeGlobals.ajaxUrl, {
				method: 'POST',
				credentials: 'same-origin',
				// body: JSON.stringify( formData )
				body: formData
			})
			.then( function( response ) {
				// The API call was successful!
				return response.text();
			}).then( function( html ) {

				if( html ) {

					// Convert the HTML string into a document object
					let parser = new DOMParser(),
						doc = parser.parseFromString( html, 'text/html' ),
						announcements = document.getElementById('announcements');

					// Vider le contenu du wrapper d'annonce au cas
					var announcementsChildren = Array.prototype.slice.call( announcements.childNodes );

					// Remove each child node
					announcementsChildren.forEach( function ( child ) {
						announcements.removeChild( child );
					} );

					announcements.innerHTML = html;

					let nbAnnouncements = doc.querySelectorAll('.announcement').length;

					if( nbAnnouncements > 0 ) {
						announcements.classList.remove('is-hidden');
					}

					// Si on a plus qu'une annonce, on va transformer la bande en swiper
					console.log( 'nbAnnouncements : ' + nbAnnouncements );

					if( nbAnnouncements > 1 ) {
						announcements.classList.add('swiper');

						let activeIndexEl = announcements.querySelector( '.swiper-count .current' ),
							totalSlidesEl = announcements.querySelector( '.swiper-count .total' );

						new Swiper( announcements, {
							modules: [ Pagination, Autoplay ],
							speed: 400,
							spaceBetween: 0,
							slidesPerView: 1,
							direction: 'horizontal',
							loop: false,
							touchEventsTarget: 'wrapper',
							preventInteractionOnTransition: true,
							effect: 'slide',
							preloadImages: true,
							shortSwipes: true,
							autoHeight: false,
							autoplay: {
								delay: 5000,
							},
							lazy: {
								loadPrevNext: true,
							},
							pagination: {
								el: ".swiper-pagination",
								clickable: true,
								type: "bullets",
							},
				  			// modules: [ Pagination, Autoplay ],
				  			on: {
				  				init: function( sw ) {
				  					activeIndexEl.textContent = sw.activeIndex +  1;
				  					totalSlidesEl.textContent = sw.slides.length;
				  				},
				  				slideChangeTransitionEnd: function( sw ) {
				  					activeIndexEl.textContent = sw.activeIndex +  1;
				  				}
				  			}
						});

					}

					document.getElementById('close-announcement').addEventListener( 'click', function (event) {
						event.preventDefault();

						let currentDate = new Date();

						let expirationDate = new Date(
							currentDate.getFullYear(),
							currentDate.getMonth(),
							currentDate.getDate() + 1,
							0, 0, 0
						);

						announcements.querySelectorAll( '.announcement' ).forEach( function( thisAnnouncement ) {
							document.cookie = thisAnnouncement.id + "=is-hidden; expires=" + expirationDate.toGMTString + "; path=/";
						});

						announcements.classList.add( 'is-hidden' );


					}, false );
				}


			}).catch( function( error ) {
				// There was an error
				console.warn('Something went wrong.', error);
			});

		}, 50 );

	} ) ();*/

	/*** Gestion des préférence de cookies ***************************************/
	(function() {
		window.acceptedCookies = cookiesBar.getCookie('acceptedCookies');

		if( 'function' == typeof cookiesBar.cookieConsent ) {
			cookiesBar.cookieConsent();
		}
	}) ();



	/*** Nombres décoratifs qui comptent vers le haut ******************************************************/
	// Requiert countUp.js
	// Pour générer des options supplémentaires https://inorganik.github.io/countUp.js/

	/* (function() {
		var countUpNumbers = Array.prototype.slice.call( document.querySelectorAll( '.countup-number' ) );
		var countUpInstances = [];

		// Faire fonctionner l'animation seulement quand on arrive près du bloc
		window.addEventListener( 'scrollinterval', function() {
			if( 'undefined' != typeof CountUp && 0 < countUpNumbers.length ) {
				countUpNumbers.forEach( function( element, index, iteratedArray ) {
					if( element && functions.isInViewport(element) ) {
						if( ! countUpInstances[index].error ) {
							element.classList.add( 'countup-counting', 'countup-init' );

							countUpInstances[index].start( function() {
								element.classList.add( 'countup-counted' );
								element.classList.remove( 'countup-counting' );
							} );
						} else {
							console.error( countUpInstances[index].error );
						}

						// On vient de lancer CountUp sur cet élément. On l'enlève de la liste des éléments à traiter.
						iteratedArray[index] = null;
					}
				} );
			}
		}, 50 );

		// Les options pour faire fonctionner l'animation
		if( 'undefined' != typeof CountUp && 0 < countUpNumbers.length ) {
			countUpNumbers.forEach( function( element, index, iteratedArray ) {
				const endNumber = parseFloat( element.innerHTML.trim() );
				const easingFn = function (t, b, c, d) {
					var ts = (t /= d) * t;
					var tc = ts * t;
					return b + c * (tc * ts + -5 * ts * ts + 10 * tc + -10 * ts + 5 * t);
				}
				const options = {
					easingFn,
					duration: 2, // Temps en seconde
				};

				countUpInstances.push( new CountUp( element, endNumber, options ) );
		
			});
		}

	}) (); */

	// Email & phone link de-obfuscation (vanilla, no inline script, with semicolons)
	(function() {
		function decodeBase64( s ) {
			try { return atob( s ); } catch (e) { return ''; }
		}

		function hydratePhone( root ) {
			var els = (root || document).querySelectorAll('.nubee-tel-obf[data-tel]');
			for (var i = 0; i < els.length; i++) {
				var el = els[i];
				if (el.dataset.nubeeHydrated === '1') { continue; }
				var tel = decodeBase64(el.getAttribute('data-tel'));
				if (!tel) { continue; }
				el.setAttribute('href', 'tel:' + tel);
				if (!el.getAttribute('title')) { el.setAttribute('title', tel); }
				el.dataset.nubeeHydrated = '1';
			}
		}

		function hydrateMail( root ) {
			var els = (root || document).querySelectorAll('.nubee-mail-obf[data-mail]');
			for (var i = 0; i < els.length; i++) {
				var el = els[i];
				if (el.dataset.nubeeHydrated === '1') { continue; }
				var mail = decodeBase64(el.getAttribute('data-mail'));
				if (!mail) { continue; }
				el.setAttribute('href', 'mailto:' + mail);
				if (!el.getAttribute('title')) { el.setAttribute('title', mail); }
				el.dataset.nubeeHydrated = '1';
			}
		}

		function hydrateAll( root ) {
			hydratePhone( root );
			hydrateMail( root );
		}

		// Public APIs if you need to call them manually
		window.nubeeTelDeobfuscate = function() { hydratePhone(document); };
		window.nubeeMailDeobfuscate = function() { hydrateMail(document); };
		window.nubeeContactDeobfuscate = function() { hydrateAll(document); };

		// Auto-init on DOM ready
		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', function() { hydrateAll(document); });
		} else {
			hydrateAll(document);
		}

		// Optional: handle content injected after load (AJAX, etc.)
		if ('MutationObserver' in window) {
			var mo = new MutationObserver(function(mutations) {
				for (var i = 0; i < mutations.length; i++) {
					for (var j = 0; j < mutations[i].addedNodes.length; j++) {
						var node = mutations[i].addedNodes[j];
						if (node && node.nodeType === 1) { hydrateAll(node); }
					}
				}
			});
			mo.observe(document.documentElement, { childList: true, subtree: true });
		}

		// Safety: prevent navigation if not yet hydrated
		document.addEventListener('click', function( e ) {
			var a = e.target.closest('a.nubee-tel-obf, a.nubee-mail-obf');
			if (!a) { return; }
			if (!a.getAttribute('href') || a.getAttribute('href') === '#') {
				e.preventDefault();
			}
		}, true);
	})();


}) ();